import * as React from "react";
import { Table } from "semantic-ui-react";

import { getIdentityValidationOptionsValue, ImmunisationListModel } from "@teamprevent/common/immunisation/models";

interface Props {
    item: ImmunisationListModel;
}

const ImmunisationRecordItem: React.FunctionComponent<Props> = (props) => {
    return (
        <Table.Row>
            <Table.Cell>{props.item.immunisationType.name}</Table.Cell>
            <Table.Cell>{props.item.dateCompleted?.format("DD/MM/YYYY")}</Table.Cell>
            <Table.Cell>{props.item.recordType}</Table.Cell>
            <Table.Cell>{props.item.outcome}</Table.Cell>
            <Table.Cell>{getIdentityValidationOptionsValue(props.item.identityValidation)}</Table.Cell>
        </Table.Row>
    );
};

export { ImmunisationRecordItem };
